import { useEffect } from "react";

function upsertMeta(name, content, isProperty = false) {
  if (!content || typeof document === "undefined") return;
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Lightweight SPA SEO — updates title + meta for crawlers that execute JS.
 */
export default function usePageSeo({ title, description, path = "/", keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta("description", description);
      upsertMeta("og:description", description, true);
      upsertMeta("twitter:description", description);
    }
    if (title) {
      upsertMeta("og:title", title, true);
      upsertMeta("twitter:title", title);
    }
    if (keywords) upsertMeta("keywords", keywords);
    if (path) {
      const url = `https://cheepsweepz.shop${path.startsWith("/") ? path : `/${path}`}`;
      upsertMeta("og:url", url, true);
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }
  }, [title, description, path, keywords]);
}
